import http from 'src/services/httpService';
import { saveAs } from 'file-saver';
import errorHandler from '../utils/error-handler';

const getFileName = (response) => {
  const disposition = response.request.getResponseHeader('Content-Disposition');
  if (!disposition || !/\battachment\b/i.test(disposition)) return '';

  const utf8 = /(?:^|;)\s*filename\*\s*=\s*UTF-8''([^;\r\n]*)/i.exec(
    disposition
  );
  if (utf8?.[1]) {
    try {
      return decodeURIComponent(utf8[1].trim());
    } catch {
      // Usa filename quando o nome UTF-8 estiver malformado.
    }
  }

  const matches = /(?:^|;)\s*filename\s*=\s*((['"]).*?\2|[^;\r\n]*)/i.exec(
    disposition
  );
  return matches?.[1]?.trim().replace(/^(['"])(.*)\1$/, '$2') ?? '';
};

export const DownloadFile = (response, fileName) => {
  let nomeArquivoServer = fileName || getFileName(response);
  // Converte o arquivo
  const file = new Blob([response.data], { type: response.data.type });
  saveAs(file, nomeArquivoServer);
};

export const ParseError = (error) => {
  if (error && error.response) {
    if (error.response.status == 400) {
      error.response.data = null;
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.type != 'application/json'
      ) {
        var enc = new TextDecoder('utf-8');
        error.response.data = JSON.parse(enc.decode(error.response.data));
      }
    }
  }

  return error;
};

export const ParseBlobError = async (error) => {
  if (error?.response?.data instanceof Blob) {
    try {
      const text = await error.response.data.text();
      error.response.data = text ? JSON.parse(text) : null;
    } catch {
      error.response.data = null;
    }
  }

  return error;
};

export const DownloadArquivoSistema = (guid, parameters = {}) => {
  http
    .post(
      'ArquivoSistema/DownloadArquivo',
      {
        guid,
        ...parameters,
      },
      {
        responseType: 'blob',
      }
    )
    .then((response) => {
      DownloadFile(response);
    })
    .catch(async (error) => {
      errorHandler(await ParseBlobError(error));
    });
};

export const DownloadFileBucket = async (
  fileName,
  convertWordToPdf = false,
  urlCustom = null,
  parameters = {},
  downloadFileName = null
) => {
  const url = urlCustom || 'File/DownloadFile';
  http
    .post(
      url,
      {
        fileName,
        convertWordToPdf,
        ...parameters,
      },
      {
        responseType: 'blob',
      }
    )
    .then((response) => {
      const nomeDownload =
        downloadFileName &&
        response.data.type === 'application/pdf' &&
        !/\.pdf$/i.test(downloadFileName)
          ? downloadFileName.replace(/\.[^.]+$/, '') + '.pdf'
          : downloadFileName;
      DownloadFile(response, nomeDownload);
    })
    .catch(async (error) => {
      errorHandler(await ParseBlobError(error));
    });
};

export const DownloadContentFileBucket = async (
  fileName,
  convertWordToPdf = false,
  urlCustom = null,
  parameters = {}
) => {
  try {
    const response = await http.post(
      urlCustom || 'File/DownloadFile',
      { fileName, convertWordToPdf, ...parameters },
      { responseType: 'blob' }
    );
    return response.data;
  } catch (error) {
    errorHandler(await ParseBlobError(error));
    throw error;
  }
};

export const DownloadArquivosSistemaZip = (items) => {
  http
    .post(
      'Anexo/DownloadArquivos',
      {
        list: items,
      },
      {
        responseType: 'blob',
      }
    )
    .then((response) => {
      saveAs(new Blob([response.data]), 'actio_files.zip');
    })
    .catch(async (error) => {
      errorHandler(await ParseBlobError(error));
    });
};

const scopes = [
  'https://graph.microsoft.com/BrowserSiteLists.Read.All',
  'https://graph.microsoft.com/Files.Read.All',
  'https://graph.microsoft.com/Sites.Read.All',
];

export const DownloadArquivoSharepoint = async (arquivo, instance) => {
  const activeAccount = instance.getActiveAccount();
  const { accessToken } = await instance.acquireTokenSilent({
    scopes: scopes,
    account: activeAccount,
  });

  const response = await fetch(
    `https://graph.microsoft.com/v1.0/sites/${arquivo.siteId}/lists/${arquivo.bibliotecaId}/items/${arquivo.arquivoId}/driveItem`,
    {
      method: 'GET',
      headers: {
        'content-type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  const data = await response.json();
  let urlDownload = data['@microsoft.graph.downloadUrl'];

  const responseDownload = await fetch(urlDownload);
  const blob = await responseDownload.blob();
  saveAs(blob, arquivo.nome);
};
